import { baseApi } from "app/baseApi";
import { apiTags } from "app/store/apiTags";

const basePath = 'quickBooksMapping';

export const quickBooksMappingApi = baseApi.injectEndpoints({
    reducerPath: 'quickBooksMappingApi',
    endpoints: (builder) => ({
        getMappings: builder.query({
            query: () => ({
                url: `${basePath}`,
                method: 'GET'
            }),
            providesTags: [apiTags.QB_MAPPING]
        }),
        addQuickBooksMapping: builder.mutation({
            query: mapping => ({
                url: `${basePath}`,
                method: "POST",
                body: mapping
            }),
            invalidatesTags: [apiTags.QB_MAPPING]
        }),
        deleteQuickBooksMapping: builder.mutation({
            query: id => ({
                url: `${basePath}/${id}`,
                method: "PUT"
            }),
            invalidatesTags: [apiTags.QB_MAPPING]
        }),
        updateQuickBooksMapping: builder.mutation({
            query: body => ({
                url: `${basePath}`,
                method: "PUT",
                body: body
            }),
            invalidatesTags: [apiTags.QB_MAPPING]
        }),
        getQuickbooksMappingByType: builder.query({
            query: ({ type }) => ({
                url: `${basePath}/byType/${type}`,
                method: 'GET'
            }),
            providesTags: [apiTags.QB_MAPPING]
        }),
    })
})

export const { useGetMappingsQuery,
    useAddQuickBooksMappingMutation,
    useDeleteQuickBooksMappingMutation,
    useUpdateQuickBooksMappingMutation,
    useGetQuickbooksMappingByTypeQuery
} = quickBooksMappingApi;
